// extracted by mini-css-extract-plugin
export default {"CardList":"index_CardList__2PyOH","cardListSuperHeading":"index_cardListSuperHeading__WRSk9","cardListItems":"index_cardListItems__MWIoG","cardListItem":"index_cardListItem__gIY6d"};